import Vote from './vote';

export default class Comment {

  constructor($element) {

    /**
     * selectors of Comment
     * @type {{footer: string, toggleCommentReply: string, downVote: string, upVote: string}}
     */
    this.SELECTORS = {
      upVote: '.js-comment-upVote',
      downVote: '.js-comment-downVote',
      toggleCommentReply: '.js-toggleCommentReply',
      footer: '.js-comment-footer',
      commentDeleteOverlay: '.comment-delete-overlay',
      commentDeleteButton: '.comment-delete',
      commentDeleteCancelButton: '.comment-delete-cancel',
    };

    /**
     * element of Comment
     */
    this.$ELEMENT = $element;

    /**
     * up-vote element
     */
    this.UP_VOTE;

    /**
     * is reply form present
     * @type {boolean}
     */
    this.REPLY_FORM_IS_PRESENT = false;

    /**
     * toggle button for reply form of Comment
     * @type {jQuery}
     */
    this.TOGGLE_REPLY_BUTTON = this.$ELEMENT.
        find(this.SELECTORS.toggleCommentReply);

    /**
     * Id of Comment
     */
    this.ID = this.TOGGLE_REPLY_BUTTON.attr('data-socialize-comment-id');

    /**
     * footer element of Comment
     */
    this.FOOTER = this.$ELEMENT.find(this.SELECTORS.footer);

    /**
     * comment delete elements
     */
    this.COMMENT_DELETE_OVERLAY = this.$ELEMENT.find(this.SELECTORS.commentDeleteOverlay);
    this.COMMENT_DELETE_BUTTON = this.$ELEMENT.find(this.SELECTORS.commentDeleteButton);
    this.COMMENT_DELETE_CANCEL_BUTTON = this.$ELEMENT.find(this.SELECTORS.commentDeleteCancelButton);

    /**
     * reply Form
     * @type {jQuery|HTMLElement}
     */
    this.REPLY_FORM = $('#replyForm');

    this.initComponents().then(_ => {
      this.registerHooks();
    });

  }

  /**
   * Initialize components for Comment
   * @private
   * @example
   * this.initComponents()
   */
  initComponents() {
    const _this = this;
    return new Promise(resolve => {
      _this.UP_VOTE = new Vote($(_this.$ELEMENT.find(_this.SELECTORS.upVote)));
      resolve();
    });
  }

  /**
   * Register events for Comment
   * @private
   * @example
   * this.registerHooks()
   */
  registerHooks() {
    const _this = this;

    _this.TOGGLE_REPLY_BUTTON.on('click', event => {
      event.preventDefault();
      _this.setCommentFormReplyId();
      _this.moveCommentFormToReply();
    });

    _this.UP_VOTE.$element.on('click', event => {
      event.preventDefault();
      _this.UP_VOTE.preventClick();
      _this.UP_VOTE.handleClick();
    });

    _this.COMMENT_DELETE_BUTTON.on('click', event => {
      _this.openCommentDeleteOverlay();
    });

    _this.COMMENT_DELETE_CANCEL_BUTTON.on('click', event => {
      _this.closeCommentDeleteOverlay();
    });

  }

  /**
   * update id of reply form
   */
  setCommentFormReplyId() {
    this.REPLY_FORM.find('#parentCommentId').val(this.ID);
  }

  /**
   * copy actual comment form for replieing to comments
   */
  moveCommentFormToReply() {
    const _this = this;
    let $textarea = _this.REPLY_FORM.find('.textarea');
    $textarea.val('');

    if (_this.REPLY_FORM_IS_PRESENT) {
      _this.REPLY_FORM.slideUp(300, function() {
      });
      _this.REPLY_FORM_IS_PRESENT = false;
      return;
    }
    _this.REPLY_FORM.slideUp(300, function() {
      _this.REPLY_FORM.insertAfter(_this.FOOTER);
      _this.REPLY_FORM.slideDown(300, () => {
        $textarea.focus();
        _this.REPLY_FORM_IS_PRESENT = true;
      });
    });
  }

  /**
   * comment delete overlay
   */
  openCommentDeleteOverlay() {
    const _this = this;

    _this.COMMENT_DELETE_OVERLAY.addClass('open');
    _this.COMMENT_DELETE_BUTTON.hide();
  }

  closeCommentDeleteOverlay() {
    const _this = this;

    _this.COMMENT_DELETE_OVERLAY.removeClass('open');
    _this.COMMENT_DELETE_BUTTON.show();
  }

}
